import { Injectable } from '@angular/core';
import { LocalStorageConstants } from './LocalStorageConstants';

@Injectable({
  providedIn: 'root'
})
export class CommonService {

  constructor() { }

  NumberToWords(amount: number): string {
    const singleDigits = ["", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine"];
    const twoDigits = ["", "Ten", "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen", "Seventeen", "Eighteen", "Nineteen"];
    const tensMultiple = ["", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"];
    const placeValues = ["", "Thousand", "Lakh", "Crore"];

    if (amount === 0) return "Zero Rupees";

    let num = Math.floor(amount);
    const paise = Math.round((amount - num) * 100);
    let words = "";

    const getTwoDigitWord = (n: number): string => {
      if (n < 10) return singleDigits[n];
      if (n < 20) return twoDigits[n - 9];
      return tensMultiple[Math.floor(n / 10)] + (n % 10 !== 0 ? " " + singleDigits[n % 10] : "");
    };

    let i = 0;
    while (num > 0) {
      let divider = i === 0 ? 1000 : 100;
      let currentNumber = num % divider;
      num = Math.floor(num / divider);

      if (currentNumber > 0) {
        let part = "";
        if (currentNumber < 100) {
          part = getTwoDigitWord(currentNumber);
        } else {
          part = singleDigits[Math.floor(currentNumber / 100)] + " Hundred ";
          part += getTwoDigitWord(currentNumber % 100);
        }
        words = part + (placeValues[i] ? " " + placeValues[i] + " " : " ") + words;
      }
      i++;
    }

    //words = words.trim() + " Rupees";
    words = words.trim();

    if (paise > 0) {
      words += " and " + getTwoDigitWord(paise) + " Paise";
    }

    return words + " Only";
  }

  // If jwt_decode is not available as a module, define it here (example implementation)
  jwt_decode(token: string | null): any {
    if (!token) return {};
    try {
      // Example: decode JWT token payload
      const payload = token.split('.')[1];
      return JSON.parse(atob(payload));
    } catch {
      return {};
    }
  }

  GetMasterDataByKey(key: string): any {
    const masterData = JSON.parse(localStorage.getItem(LocalStorageConstants.MASTER_DATA));
    var masterDetails = masterData.filter(function (d) {
      return d.master_Code == key;
    });

    return masterDetails[0].master_Description;
  }

   GetInvoiceConfiguration()
   {
     return {
      invoiceAddress: this.GetMasterDataByKey('InvoiceAddress') || 'not configured',
      invoiceEmail: this.GetMasterDataByKey('InvoiceEmail') || 'not configured',
      invoiceContactNo: this.GetMasterDataByKey('InvoiceContactNo') ||  'not configured',
      invoiceDeclaration: this.GetMasterDataByKey('InvoiceDeclaration') ||  'not configured',
      invoicePaymentTerm: this.GetMasterDataByKey('InvoicePaymentTerm') ||  'not configured',
      invoiceBankAcNo: this.GetMasterDataByKey('InvoiceBankAcNo') ||  'not configured',
      invoiceBankIFSC: this.GetMasterDataByKey('InvoiceBankIFSC') ||  'not configured',
      invoiceBankBranch: this.GetMasterDataByKey('InvoiceBankBranch') ||  'not configured',
      invoiceBankGSTNo: this.GetMasterDataByKey('InvoiceBankGSTNo') ||  'not configured',
      invoiceBankName: this.GetMasterDataByKey('InvoiceBankName') ||  'not configured',
      clientLogoUrl: this.GetMasterDataByKey('ClientLogoUrl') ||  'assets/images/logo/logo.png',
    };
   } 
}


